<template>
    <div class="member_bg">
        <div class="content member">
            <div class="mem_mento"> 멘토소개</div>
            <div class="mem_allview" @click="movePage()"> 전체보기</div>
            <swiper ref="mySwiper" :options="swiperOptions" class="member_swiper">
                <swiper-slide v-for="(member, index) in memberData" :key="`member${member.m_idx}`">
                    <div class="slide_pic">
                        <img class="member_img" :src="returnProfile(member)">

                    </div>
                    <div class="slide_name">{{member.m_name}}</div>
                    <div class="slide_job" v-html="member.m_job"></div>
                    <div class="slide_description" v-html="returnTextArea(member.m_memo)"></div>
                </swiper-slide>
            </swiper>

            <div class="swiper-button-prev btn_prev" slot="button-prev"></div>
            <div class="swiper-button-next btn_next" slot="button-next"></div>
        </div>
    </div>
</template>

<script>
    import imageOption from "@/mixins/imageOption";
    import {Swiper, SwiperSlide, directive} from 'vue-awesome-swiper'
    import 'swiper/swiper-bundle.css'
    import SwiperCore, {Navigation} from 'swiper';
    import 'swiper/components/navigation/navigation.scss';
    import util from "@/mixins/util";

    SwiperCore.use([Navigation]);

    export default {
        name: "MemberListHomeLayout",
        mixins: [imageOption],
        components: {
            Swiper,
            SwiperSlide
        },
        props: {
            memberData: {
                type: Array,
                default: () => {
                    return []
                }
            },
        },
        data() {
            return {
                mentorList: [
                    {
                        mb_name: '김혜준',
                        mb_job: '아나운서',
                        mb_memo: '심하게 다이어트를 한 호빵맨입니다. 사단법인 함꼐하는 아버지들의 대표로 일하고 있습니다^^'
                    },
                    {
                        mb_name: '김혜준',
                        mb_job: '사회운동가',
                        mb_memo: '심하게 다이어트를 한 호빵맨입니다. 사단법인 함꼐하는 아버지들의 대표로 일하고 있습니다^^'
                    },
                    {
                        mb_name: '김혜준',
                        mb_job: '소설가',
                        mb_memo: '심하게 다이어트를 한 호빵맨입니다. 사단법인 함꼐하는 아버지들의 대표로 일하고 있습니다^^'
                    },
                    {
                        mb_name: '김혜준',
                        mb_job: '부산지방경찰청장',
                        mb_memo: '심하게 다이어트를 한 호빵맨입니다. 사단법인 함꼐하는 아버지들의 대표로 일하고 있습니다^^'
                    },
                    {
                        mb_name: '김혜준',
                        mb_job: '부산지방경찰청장',
                        mb_memo: '심하게 다이어트를 한 호빵맨입니다. 사단법인 함꼐하는 아버지들의 대표로 일하고 있습니다^^'
                    },
                    {
                        mb_name: '김혜준',
                        mb_job: '부산지방경찰청장',
                        mb_memo: '심하게 다이어트를 한 호빵맨입니다. 사단법인 함꼐하는 아버지들의 대표로 일하고 있습니다^^'
                    },
                    {
                        mb_name: '김혜준',
                        mb_job: '부산지방경찰청장',
                        mb_memo: '심하게 다이어트를 한 호빵맨입니다. 사단법인 함꼐하는 아버지들의 대표로 일하고 있습니다^^'
                    },
                    {
                        mb_name: '김혜준',
                        mb_job: '부산지방경찰청장',
                        mb_memo: '심하게 다이어트를 한 호빵맨입니다. 사단법인 함꼐하는 아버지들의 대표로 일하고 있습니다^^'
                    },
                ],
                swiperOptions: {
                    slidesPerView: 4,
                    spaceBetween: 15,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    },
                },
            }
        },
        beforeRouterEnter() {
        },
        created() {
        },
        mounted() {

        },
        beforeDestroy() {
        },
        destroyed() {
        },
        computed: {
            swiper() {
                return this.$refs.mySwiper.$swiper
            }
        },
        directives: {
            swiper: directive
        },
        methods: {
            returnProfile(member) {
                return !util.isEmpty(member.profile) ? `${member.profile[0].org_url}?${this.setImageOptions(129, 129, 'jpg')}` : ''
            },
            returnTextArea(text){
                if(util.isEmpty(text)) {
                    return ''
                }
                return text.replace(/(\n|\r\n)/g, '<br>');
            },
            movePage(){
                this.$router.push('/amidan?tab=mentor')
            }
        },
        watch: {},
    }
</script>

<style lang="scss">
    .btn_prev {
        &:after {
            content: '';
        }
    }

    .btn_next {
        left: 40px;

        &:after {
            content: '';
        }
    }

</style>